import { IProductHelperStrategy } from './product-helper-strategy.interface';
import { ProductHelperStrategyV1 } from './product-helper-strategy.v1';

export enum ProductHelperVariant {
  MPS_v1 = 'MPS_v1',
}

export class ProductHelperFactory {
  private static readonly STRATEGY_MAP = new Map<ProductHelperVariant, IProductHelperStrategy>([
    [ProductHelperVariant.MPS_v1, new ProductHelperStrategyV1()],
  ]);

  static create<T extends IProductHelperStrategy>(variant: ProductHelperVariant): T {
    const strategy = this.STRATEGY_MAP.get(variant);

    if (!strategy) {
      throw new Error('Unable to create strategy');
    }
    return strategy as T;
  }

  static createMpsV1<T extends IProductHelperStrategy = ProductHelperStrategyV1>(): T {
    return this.create<T>(ProductHelperVariant.MPS_v1);
  }
}
